import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Hooks/useAuth';
import { startInterviewPrefetch } from '../Pages/Interview/interviewPrefetch';
import { startHiredProfilesPrefetch } from '../Pages/HiredProfiles/hiredProfilesPrefetch';
import { startOverviewPrefetch } from '../Pages/Overview/overviewPrefetch';
import { startMyJobsPrefetch } from '../Pages/MyJobs/myJobsPrefetch';
import { useCompanyAccess } from '../Context/CompanyAccessContext';
import { AccessCheckFailed, NoAccess } from './NoAccess';

/**
 * @param {string|string[]} [permission] the person needs this, or any one of a list.
 *   A team member without it sees a no-access page and stays signed in.
 * @param {boolean} [forInterviewers] an Interviewer may open this page. They reach
 *   single candidates, never whole jobs, so every other page sends them to
 *   "My interviews".
 */
export const HireWithUsProtectedRoute = ({ children, permission, forInterviewers = false }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const access = useCompanyAccess();
  const prefetchStarted = useRef(false);

  // Prefetch Overview, My Jobs, Interview, and Hired Profiles data in background once authenticated
  // useEffect(() => {
  //   if (!isAuthenticated || isLoading || prefetchStarted.current) return;
  //   prefetchStarted.current = true;
  //   startOverviewPrefetch();
  //   startMyJobsPrefetch();
  //   startInterviewPrefetch();
  //   startHiredProfilesPrefetch();
  // }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Verifying authentication...
      </div>
    );
  }

  if (!isAuthenticated) {
    // Debug log removed — was leaking auth-state hint on every protected-route render.
    return <Navigate to="/hirewithus/login" replace />;
  }

  if (!forInterviewers && access.scope === 'assigned_interviews') {
    return <Navigate to="/hirewithus/my-interviews" replace />;
  }

  if (permission && !access.can(permission)) {
    if (access.ready) return <NoAccess />;
    if (access.failed) return <AccessCheckFailed onRetry={access.retry} />;
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Checking your access...
      </div>
    );
  }

  // Debug log removed — was leaking auth-state hint into every page render.
  return children;
};
